import { useEffect } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { commitAttributionToProfile } from '@/lib/gclidCapture';

/**
 * Persist captured ad-click attribution for any authenticated user session, so
 * returning users do not need to pass through /welcome before checkout.
 */
const AttributionProfileCommitter = () => {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  useEffect(() => {
    if (!userId) {
      return;
    }

    void commitAttributionToProfile(supabase, userId);
  }, [userId]);

  return null;
};

export default AttributionProfileCommitter;
